class WCCartNotification extends WCOutsideListener(WCDummy) {
  constructor() {
    super({ tag: WCCartNotification.tag });
    this.items = this.querySelector("template").content.cloneNode(true);
    this.markup = document.createElement("div");
    this.markup.classList.add("rows");
    this.insertBefore(this.markup, this.querySelector("template"));
    this.closeButtons = this.querySelectorAll(`${this.tag}-close`);
  }

  static get tag() {
    return "wc-cart-notification";
  }

  static get observedAttributes() {
    return ["open"];
  }

  attributeChangedCallback() {
    if (this.open) {
      this.addOutsideListener();
    } else {
      this.removeOutsideListener();
    }
  }

  connectedCallback() {
    document.addEventListener(
      "cartChangedDiff",
      this.#handleCartChange.bind(this)
    );
    ShopifyAjaxAPI.cart;
    this.style.setProperty(
      "--offset",
      document.querySelector("#shopify-section-header").offsetHeight + "px"
    );
    this.closeButtons.forEach((button) =>
      button.addEventListener("click", this.#handleClose.bind(this))
    );
  }

  disconnectedCallback() {
    document.removeEventListener(
      "cartChangedDiff",
      this.#handleCartChange.bind(this)
    );
    this.closeButtons.forEach((button) =>
      button.removeEventListener("click", this.#handleClose.bind(this))
    );
  }

  get open() {
    return this.hasAttribute("open");
  }

  async #handleCartChange(e) {
    this.#render(e.detail);
  }

  #handleClose() {
    this.removeAttribute("open");
  }

  async #render(cart) {
    this.markup.innerHTML = "";
    document.querySelector("#CartCount").innerText = parseHTML(
      cart.sections["cart-icon"]
    ).querySelector("#shopify-section-cart-icon").innerText;
    cart.items.forEach((cartItem) => {
      const item = this.items.cloneNode(true);
      item.querySelectorAll("wc-live-region").forEach((item, i) => {
        switch (i) {
          case 0:
            const image = document.createElement("img");
            image.src = cartItem.image + "&height=240&width=240&crop=center";
            image.width = 80;
            image.height = 80;
            item.replaceWith(image);
            break;
          case 1:
            const title = document.createElement("span");
            title.innerHTML = cartItem.product_title;
            item.replaceWith(title);
            break;
          case 2:
            if (!cartItem.variant_title.includes("Default")) {
              const options = document.createElement("small");
              options.innerText = cartItem.variant_title;
              item.replaceWith(options);
            }
            break;
          case 3:
            const quantity = document.createElement("span");
            quantity.innerHTML = cartItem.quantity;
            item.replaceWith(quantity);
            break;

          default:
            break;
        }
      });
      const row = document.createElement("div");
      row.classList.add("row");
      Array.from(item.children).forEach((d) => row.append(d));
      this.markup.append(row);
    });
  }

  outsideListenerCallback() {
    this.#handleClose();
  }
}
customElements.define(WCCartNotification.tag, WCCartNotification);
